'use client'

import { memo } from 'react'

import { AppliedDiscountCode } from 'modules/benefitCodes'
import { addTestId } from 'shared/utils/tests'

import CartActiveDiscountCode from './CartActiveDiscountCode'

import styles from './CartActiveBenefitCodes.module.scss'

interface CartActiveBenefitCodesProps {
  activeCodes: AppliedDiscountCode[]
  handleRemoveCode: (codeId: string) => () => void
}

const CartActiveBenefitCodes = memo(
  ({ activeCodes, handleRemoveCode }: CartActiveBenefitCodesProps) => {
    if (!activeCodes.length) return null

    return (
      <div>
        <div className={styles.activeCodesWrapper}>
          <div
            className={styles.activeCodesDescription}
            {...addTestId('active-codes-description')}
          >
            Aktywowane kody
          </div>
          <ul className={styles.activeCodesList}>
            {activeCodes.map(code => (
              <li className={styles.activeCodesListItem} key={code.id}>
                <CartActiveDiscountCode
                  code={code}
                  handleRemoveCode={handleRemoveCode(code.id)}
                />
              </li>
            ))}
          </ul>
        </div>
        <hr className={styles.hr} />
      </div>
    )
  }
)

export default CartActiveBenefitCodes
